import { render } from "./SecureSeal.vue?vue&type=template&id=7dc35808"
import script from "./SecureSeal.vue?vue&type=script&lang=js"
export * from "./SecureSeal.vue?vue&type=script&lang=js"

import exportComponent from "/builds/commerce/central/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__